import React from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import background from './img/background-body.jpg';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  document.body.style.backgroundImage = `url(${background})`;
  document.body.style.backgroundRepeat = 'no-repeat';
  document.body.style.backgroundSize = 'cover';
  document.body.style.backgroundPosition = 'top';
  document.body.style.backgroundAttachment = 'fixed';
  const api = new ServiceApi(this);
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type) {
      return false;
    }
    return true;
  }

  document.body.className = 'puntonet-oauth-body';
  document.title = 'Puntonet';

  return (
    <div className="puntonet-oauth">
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
            parameters={parameters}
            translate={translate}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
    </div>
  );
}

export default Login;
